<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px">
  <div class="content container-fluid">
    <div class="bg-white page-border">
      <!--page body contant -->
      <!--header-->
      <div class="row row-replace add-m-b">
        <!-- header  -->
        <div class="col-md-6 col-9 col-p h5">
          <i class="fa fa-medkit"></i> Mediclaim Helpdesk
        </div>
        <div class="col-md-6 col-3 top-corner-items col-p">
          <button class="btn btn-primary btn-sm" routerLink="/dashboard">
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>
      <!--end header-->

      <div class="row m-t-30">
        <div class="col-md-6 d-flex">
          <div class="card flex-fill add-mrf-card">
            <div class="card-body card-padding-bottom">
              <h3 class="card-title page-header0">
                <i class="fa fa-book"></i> Family Member Under Mediclaim
                <div *ngIf="disbaled == '0' && Type == '2'" class="edit-icon">
                  <i
                    class="fa fa-plus"
                    (click)="
                      open_family_modal('#add_family_form', 'Add Family Member')
                    "
                  ></i>
                </div>
              </h3>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <h3 class="card-title page-header0">Mediclaim Condition</h3>
                  <span>
                    1. Coverage - Employee + Family (spouse and two dependent
                    children upto 25 age)
                  </span>
                  <br />
                  <span>
                    2. Mediclaim Coverage will not be applicable, if employee
                    covered under ESIC
                  </span>
                  <br />
                  <span>
                    3. Mediclaim Coverage will be applicable, if employee
                    earning is greater than INR 21000/-
                  </span>
                  <br />
                </div>
              </div>
              <br />
              <div class="experience-box add-p-b10">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Relation</th>
                      <th>DOB</th>
                      <th>Is Mediclaim</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of empFamList">
                      <td>{{ data.dpndt_name }}</td>
                      <td>{{ data.option_desc }}</td>
                      <td>{{ data.dpndt_dob }}</td>
                      <td>{{ data.is_under_mediclaim }}</td>
                      <td>
                        <span *ngIf="disbaled == 0">
                          <i
                            (click)="
                              editFamily(data.dpndt_id, 'Edit Family Member')
                            "
                            class="fa fa-pencil"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <button
                  *ngIf="Type == '2'"
                  [disabled]="disTrue"
                  type="submit"
                  (click)="freezeFamilyDetails()"
                  class="btn btn-danger btn-sm"
                >
                  Finish
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="table-responsive">
            <table class="table">
              <tr class="bg-primary text-white">
                <th width="100">TO GENERATE E CARD LOGIN TO</th>
              </tr>
              <tr>
                <td>
                  <p>
                    <a
                      href="#"
                      target="_blank"
                      style="color: dodgerblue"
                      >#</a
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <!-- <h2 style="font-size: 20px;font-weight:500;padding: 5px 0;"> To generate E card on mobile app or web site:</h2>
                                        <br> -->
                    <h3>
                      Login ID : Employee ID <br />
                      Password: Date of Birth (DD/MM/ YYYY)
                    </h3>
                    <p>
                      Employee can view – ecard, Network hospital, Policy
                      Benefit & FAQ, claim Procedure, TPA contact details etc.
                    </p>
                  </div>
                </td>
              </tr>
            </table>
            <br />
            <p>{{ content.wellness_label }}</p>
            <H4 style="color:red">Click Here</H4>           
            <p>
              <a href="{{ content.lab_img }}" target="_blank" download
                ><i
                  class="fa fa-download"
                  aria-hidden="true"
                  style="color: red"
                ></i>
                {{ content.initiative }}</a
              >
            </p>
            <p>
              <a href="{{ content.wellness_img }}" target="_blank" download
                ><i
                  class="fa fa-download"
                  aria-hidden="true"
                  style="color: red"
                ></i>
                {{ content.centers }}</a
              >
            </p>
          </div>
        </div>
      </div>
      <div class="row m-t-10">
        <!-- <div class="col-md-6">
                    <div class="table-responsive">
                        <table class="table">
                            <tr class="bg-primary text-white">
                                <th width="100">Sr No.</th>
                                <th>Title</th>
                                <th width="150">Download PDF</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Cashless Process</td>
                                <td>Download PDF</td>
                            </tr>
                        </table>
                    </div>
                </div> -->
        <div class="col-md-6" *ngFor="let data of mediclaimDocs">
          <div class="table-responsive">
            <table class="table bg-primary text-white m-0 default-table">
              <tr>
                <th>{{ data.tpc_desc }}</th>
              </tr>
            </table>
            <table class="table">
              <tr class="bg-primary text-white">
                <th width="100">Sr No.</th>
                <th>Title</th>
                <th width="150">Download Template</th>
              </tr>
              <tr *ngFor="let subtpc of data.subtpcs; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ subtpc.label }}</td>
                <td *ngIf="subtpc.attachment">
                  <a href="{{ subtpc.attachment }}" target="_blank">
                    Download</a
                  >
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!--end page body contant -->
    </div>
  </div>
</div>
<!-- /Page Wrapper -->

<!-- start Family modal -->
<div id="add_family_form" class="modal custom-modal fade" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ dynamicHeader }}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form
        [formGroup]="familyForm"
        (ngSubmit)="onSubmitFamily()"
        class="horizontal-form"
        method="post"
        enctype="multipart/form-data"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Person Name<span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  type="text"
                  formControlName="dpndt_name"
                />
                <div
                  *ngIf="submitted && famErrorMsg.dpndt_name.errors"
                  class="form-error"
                >
                  <div *ngIf="famErrorMsg.dpndt_name.errors.required">
                    Name is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Relation<span class="text-danger">*</span></label>
                <select class="form-control" formControlName="dpndt_rln_id">
                  <option value="">Select Relation</option>
                  <option
                    value="{{ data.option_id }}"
                    *ngFor="let data of empRelation"
                  >
                    {{ data.option_desc }}
                  </option>
                </select>
                <div
                  *ngIf="submitted && famErrorMsg.dpndt_rln_id.errors"
                  class="form-error"
                >
                  <div *ngIf="famErrorMsg.dpndt_rln_id.errors.required">
                    Relation is required !
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Cover Mediclaim</label>
                <select class="form-control" formControlName="cover_med">
                  <option>Select</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
                <div
                  *ngIf="submitted && famErrorMsg.cover_med.errors"
                  class="form-error"
                >
                  <div *ngIf="famErrorMsg.cover_med.errors.required">
                    Cover Mediclaim is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>DOB</label>
                <input
                  type="date"
                  class="form-control"
                  *ngIf="famType == '30' || famType == '31'"
                  [min]="maxDob"
                  formControlName="fam_dob"
                />
                <input
                  type="date"
                  class="form-control"
                  *ngIf="famType == '40'"
                  formControlName="fam_dob"
                />

                <div
                  *ngIf="submitted && famErrorMsg.fam_dob.errors"
                  class="form-error"
                >
                  <div *ngIf="famErrorMsg.fam_dob.errors.required">
                    Dob is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            [disabled]="loading"
            class="btn btn-primary btn-sm"
          >
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm mr-1"
            ></span
            ><i class="fa fa-save"></i> SAVE
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            (click)="onResetFamily()"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- end -->
